import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fdbfzafa7a: FaireBrandEntity = {
  token: "b_fdbfzafa7a",
  type: "brand",
  name: "Scottsdale Candle Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/7c7c2322563372f7e0be9794bae1650f5deb4dee5ae5c6e7afa8634bd1825dc6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b86e20bcab7ec983f3cb31048c2f3ab610566f42f6cf1bf0942fe712be39dbe7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7c7c2322563372f7e0be9794bae1650f5deb4dee5ae5c6e7afa8634bd1825dc6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b86e20bcab7ec983f3cb31048c2f3ab610566f42f6cf1bf0942fe712be39dbe7.png",
  location: "Scottsdale, AZ, USA",
  minimumOrderDollars: 120,
  rating: 5,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    "Scottsdale Candle Co believes in creating sustainable candles that hold connections and stories, created from repurposed champagne and liquor bottles*\n\nOur candles are hand crafted in Scottsdale, AZ giving them their own variations in the glass and labels. Imperfections should be expected, as these bottles have a story of their own, each one coming from a local bar or restaurant. \n\nUnlike most candle companies, we offer an array of different bottles all with 100% soy wax and one signature scent; a sweet blend of tangy grapefruit with a punch of citrus, peach and a hint of vanilla. \n\nWe hope you enjoy!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:52.905Z",
    importedBy: "entity-db-cli",
  },
};
